import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { media } from '../../src/styles/media';
import { Section, HorizontalCard } from '../../src/components/Layout';
import { Container, Row, Column } from '../../src/components/Grid';
import { H4 } from '../../src/components/Title';
import Button, { LinkBadge } from '../../src/components/Button';
import Text from '../../src/components/Typography/Text';
import theme from '../../src/theme';
import Wysiwyg from '../../src/components/Wysiwyg';

const ItemContent = styled.div`
  margin: 10px 0;

  p {
    font-size: ${props => props.theme.font.body2.fontSize};
    line-height: ${props => props.theme.font.body2.lineHeight};
  }

  li::before {
    background: none;
  }

  li {
    font-size: ${props => props.theme.font.body2.fontSize};
    line-height: ${props => props.theme.font.body2.lineHeight};
    padding-left: 0px;
  }
`;

const ContentWrapper = styled.div`
  margin-top: 32px;
`;

class Access extends React.PureComponent {
  renderAccesses = (item, index) => {
    const { detail } = item;

    return (
      <Column key={index} tablet={2} desktop={2} space={5}>
        <Text variant="heading3" as="h3" color={theme.color.brand.accent}>
          {detail.title}
        </Text>
        <ItemContent>
          <Wysiwyg content={detail.description} />
        </ItemContent>
        {detail.cta_label && detail.cta_url ? (
          <Button iconType="arrow-top-right" href={detail.cta_url} targetBlank>
            {detail.cta_label}
          </Button>
        ) : null}
      </Column>
    );
  };

  render() {
    const { data, t, imgMobile, img } = this.props;

    return (
      <Section>
        <Container>
          <Fade up>
            <HorizontalCard
              img={img}
              imgMobile={imgMobile}
              title={t('common:infos.access.title')}
              icon="access"
              imgPosition="left"
              badge={false}
              contentPosition={'start'}
            >
              <ContentWrapper>
                <Row space={5}>{data.map(this.renderAccesses)}</Row>
              </ContentWrapper>
            </HorizontalCard>
          </Fade>
        </Container>
      </Section>
    );
  }
}

Access.propTypes = {
  data: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  imgMobile: PropTypes.string,
  img: PropTypes.string
};

export default translate()(Access);
